module.exports = __webpack_public_path__ + "static/media/signature.38f438e8.png";